import { createSlice } from "@reduxjs/toolkit";
import { PersonTeamDTO } from "../../models/PersonTeam.model";
import { loginUser } from "../thunks/authThunks";
import { refreshCompanyData } from "../thunks/companyDataThunks";

export interface UserState {
  personTeams: PersonTeamDTO[];
  loading: boolean;
  error: string | null;
  initialized: boolean;
}

const initialState: UserState = {
  personTeams: JSON.parse(sessionStorage.getItem("personTeams") || "[]"),
  loading: false,
  error: null,
  initialized: !!sessionStorage.getItem("personTeams"),
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
    clearPersonTeams: (state) => {
      state.personTeams = [];
      state.initialized = false;
      state.error = null;
      sessionStorage.removeItem("personTeams");
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(loginUser.fulfilled, (state, action) => {
        const { personTeams } = action.payload;
        if (personTeams && personTeams.length > 0) {
          state.personTeams = personTeams;
          state.initialized = true;
          state.error = null;
          sessionStorage.setItem("personTeams", JSON.stringify(personTeams));
        }
      })
      .addCase(refreshCompanyData.fulfilled, (state, action) => {
        const { personTeams } = action.payload;
        if (personTeams && personTeams.length > 0) {
          state.personTeams = personTeams;
          state.initialized = true;
          state.error = null;
          sessionStorage.setItem("personTeams", JSON.stringify(personTeams));
        }
      })
      .addCase(refreshCompanyData.rejected, (state, _action) => {
        state.loading = false;
        state.error = "שגיאה בטעינת נתוני המשתמש";
      });
  },
});

export const { clearError, clearPersonTeams } = userSlice.actions;
export default userSlice.reducer;
